import React from 'react';
import MotionF from '../components/MotionF';


const LeaderboardComponent = () => {
    return (
        <div>
            <h2>Leaderboard</h2>
        </div>
        
    );
};

const Leaderboard = MotionF(LeaderboardComponent);

export default Leaderboard;
